import { render, staticRenderFns } from "./TheDrawerThemeSwitcher.vue?vue&type=template&id=5f83808a"
import script from "./TheDrawerThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./TheDrawerThemeSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports